import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SiteConfig } from "src/app/models/site.config.models";
import { BrandingService } from "src/app/services/branding.service";
import { HttpService } from "src/app/services/http.service";
import { Referee, RefereeStatus } from "./referencing.models";
import { ErrorHandlerService } from "src/app/services/error-handler.service";

@Component({
    selector: 'referencing',
    templateUrl: './referencing.page.html',
    styleUrls: ['./referencing.page.scss'],
    standalone: false
})
export class ReferencingPage  {
  public branding: SiteConfig|null = null;
  public editingReferee: boolean = false;
  public referees: Referee[] = [];
  public currentReferee: Referee | null = null;
  public isEditForm = false;

  public user?: string;
  public companyName: string = '';
  public role: string = '';
  public clientEmail: string = '';

  constructor(
    brandingService: BrandingService,
    private httpService: HttpService,
    private router: Router,
    private errorHandler: ErrorHandlerService
  ){
    brandingService.branding$.subscribe(b => {
      this.branding = b;
    });
    this.httpService.getReferenceApplicantRequestStatusAndBasicInfo().subscribe({
      next: result => {
        if (!(result.status == 'InProgress' || result.status == 'ProceedWithHire')){
          this.router.navigateByUrl('cancelled');
        }

        this.user = result.applicantName;
        this.companyName = result.companyName;
        this.role = result.jobTitle;
        this.clientEmail = result.clientEmail;

        let hideIncomplete = result.status == 'ProceedWithHire';

        this.httpService.getReferees().subscribe({
          next: result => {
            this.referees = hideIncomplete ? result.referees.filter(r => r.status == RefereeStatus.ReferenceCompleted) : result.referees;
          },
          error: error => {
            this.errorHandler.handleError(error);
          }
        });
      },
      error: error => {
        this.errorHandler.handleError(error);
      }
    });
  }

  public onAddDetailsPressed(referee: Referee): void {
    this.currentReferee = referee;
    this.isEditForm = !!this.currentReferee.firstName;
  }

  public closeRefereeForm(refereeToSave: Referee): void {
    this.httpService.saveRefereeDetails(refereeToSave).subscribe({
      next: result => {
        this.httpService.sendRefereeEmail(refereeToSave.id).subscribe({
          next: sendResult => {
            // TODO: Toast to say it's sent?
          }
        });
      },
      error: error => {
        this.errorHandler.handleError(error, 'Problem saving form', 'There was a problem saving the form');
      }
    });

    this.referees.map( (referee, index) => {
      if(referee.id === refereeToSave.id){
        this.referees[index] = refereeToSave;
      }
    });
    this.currentReferee = null;
  }

  public closeForm(): void {
    this.currentReferee = null;
  }
}
